import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  selectPreviousBranchesWorkingHours,
  selectToken,
} from "../../../../../../redux-store/selectors";
import { updateBranchesWorkingHoursAction } from "../../../../constants/actions";
import {
  updateBranchesWorkingHours,
  updateBranchesWorkingHoursFailure,
  updateBranchesWorkingHoursSuccess,
} from "../../../actions/Manager";
import { updateBranchesWorkingHoursApi } from "../../../../axios/Manager";
import { union } from "ts-action";
import { notify } from "react-notify-toast";
import { BranchesWorkingHoursState } from "../../../../../../types/Manager";

const actionTypes = union({ updateBranchesWorkingHours });

function* updateBranchesWorkingHoursSaga({ payload }: typeof actionTypes) {
  try {
    if (!payload.reason) {
      yield put(updateBranchesWorkingHoursFailure(new Error("Reason is required")));
      return;
    }
    const token = yield select(selectToken);
    const prevBranchesHours: BranchesWorkingHoursState["previousBranchesWorkingHours"] =
      yield select(selectPreviousBranchesWorkingHours);
    yield call(updateBranchesWorkingHoursApi, token, payload);
    yield put(
      updateBranchesWorkingHoursSuccess({
        ...payload,
        __prevBranchesHours: prevBranchesHours,
      })
    );

    notify.show("Working hours updated successfully", "success");
  } catch (error) {
    yield put(updateBranchesWorkingHoursFailure(error as Error));
    notify.show("Failed to update store working hours!", "error");
  }
}

export function* watchUpdateBranchesWorkingHours() {
  yield takeLatest(
    updateBranchesWorkingHoursAction.requested,
    updateBranchesWorkingHoursSaga
  );
}
